export default __webpack_public_path__ + "static/media/alipay.de4d494a.svg";